export default __webpack_public_path__ + "static/media/cmk2020-main-baner.d4291426.png";